import { GetNetworkQuery } from '@coris-ts/repository/query/network.query'
import type { HttpParameters } from '@coris-ts/data/parameter-type'
import { ApiEndpoint } from '../../../../shared/api-endpoint'
import { computeDateRange } from '../../../../shared/helpers/date.functions'

export class GetCashFlowQuery extends GetNetworkQuery {
  constructor(
    private readonly month: string,
    private readonly totalMonths: number,
    private readonly organization: string
  ) {
    super(ApiEndpoint.RevenueCashFlow)
  }

  public get queryParameters(): HttpParameters {
    const { fromDate, toDate } = computeDateRange(this.month, this.totalMonths)
    return {
      month: this.month,
      total_months: this.totalMonths,
      organization: this.organization,
      from_date: fromDate,
      to_date: toDate
    }
  }
}
